import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/videos/VideoWatchExperience.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
